import ModelState, {related, Model} from './_util/model';

class CityModel extends Model {
  @related('country_id', false, 'countries') country;
}

class CitiesState extends ModelState {
  get url() { return '/cities'; }
  get singular() { return 'city'; }
  get plural() { return 'cities'; }

  get Model() { return CityModel; }
}

export default CitiesState;



// WEBPACK FOOTER //
// ./spa/state/cities.jsx